import DOMPurify from 'dompurify';

// Links may legitimately use target="_blank", which is not in DOMPurify's
// default allow-list. Re-allow it, but force rel="noopener noreferrer" on any
// link that opens a new tab so we don't reintroduce reverse-tabnabbing.
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A' && node.hasAttribute('target')) {
    const rel = new Set(
      (node.getAttribute('rel') || '').split(/\s+/).filter(Boolean),
    );
    rel.add('noopener');
    rel.add('noreferrer');
    node.setAttribute('rel', Array.from(rel).join(' '));
  }
});

/**
 * Render-safe HTML sanitizer for use with dangerouslySetInnerHTML.
 *
 * Allows ordinary formatting markup (bold, links, lists, etc.) while removing
 * scripts, event-handler attributes (onerror/onload/onclick/...), and
 * javascript: URLs. Uses DOMPurify's default profile (the most permissive
 * configuration that is still safe against XSS), plus target on links.
 *
 * Note: this is distinct from ./sanitize, which fully escapes HTML to inert
 * text. Use sanitizeHtml when the markup is meant to render; use sanitize when
 * it should be shown literally.
 */
export default function sanitizeHtml(dirty) {
  return DOMPurify.sanitize(dirty ?? '', { ADD_ATTR: ['target'] });
}
